import { TotalFeeResponse } from "../../objects/report/totalFeeResponse";
import { FeeTotal } from "../../objects/report/feeTotal";
import * as _ from "lodash";
import * as moment from "moment";

/**
 * Created by alex.y on 12/15/2017.
 */
export class ChartsHelper {
    public static convertAndCutDate(totalFeeResponses: Array<TotalFeeResponse>, startDate: Date, endDate: Date): void {
        for (let tf of totalFeeResponses) {
            for (let ft of tf.FeeTotals) {
                ft.Date = new Date(moment(`${ft.Date}`).local().format('MM/DD/YYYY'));
            }
        }

        this.groupByDate(totalFeeResponses, startDate, endDate);
    }

    public static groupByDate(totalFeeResponses: Array<TotalFeeResponse>, startDate: Date, endDate: Date): void {
        for (let tf of totalFeeResponses) {
            let summaryFeeTotal = new Array<FeeTotal>();

            for (let i = 0; i < tf.FeeTotals.length - 1; i++) {
                if (tf.FeeTotals[i].Date < startDate || tf.FeeTotals[i].Date > endDate) {
                    tf.FeeTotals.splice(i, 1);
                    i--;
                }
            }

            let grouped = _.groupBy(tf.FeeTotals, "Date");

            for (let g of <Array<any>>_.values(grouped)) {
                if (g.length == 0)
                    continue;

                let newFeeTotal = new FeeTotal();
                newFeeTotal.Date = g[0].Date;
                newFeeTotal.Total = _.sumBy(g, "Total");

                summaryFeeTotal.push(newFeeTotal);
            }

            tf.FeeTotals = summaryFeeTotal;
        }
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/chartsHelper.ts